export const common = {
  appName: 'Allocation Planning',
  sidebarTitle: 'Alloc. planning',
  yes: 'Yes',
  no: 'No',
  save: 'Save',
  cancel: 'Cancel',
  close: 'Close',
  loading: 'Loading...',
  pagination: {
    navigation: 'Pagination',
    previous: 'Previous page',
    next: 'Next page',
    page: 'Page {{page}}',
  },
  sidebarToggle: 'Toggle sidebar',
  datePicker: {
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    previousYear: 'Previous year',
    nextYear: 'Next year',
    previousDecade: 'Previous decade',
    nextDecade: 'Next decade',
    today: 'Today',
    clear: 'Clear',
    openCalendar: 'Open calendar',
    closeCalendar: 'Close calendar',
    selectDate: 'Select date',
    selectRange: 'Select range',
    selectMonth: 'Select month',
    selectYear: 'Select year',
    selectQuarter: 'Select quarter',
    selectWeek: 'Select week',
    selectTime: 'Select time',
    monthYearDropdown: 'Choose month and year',
  },
  tableFilters: {
    trigger: 'Filter by {{column}}',
    triggerActive: 'Filter by {{column}} (filter applied)',
    title: 'Filter {{column}}',
    apply: 'Apply',
    clear: 'Clear',
    textPlaceholder: 'Contains…',
    textInputLabel: 'Text to filter {{column}}',
    optionsSearchPlaceholder: 'Search…',
    optionsSearchLabel: 'Search in {{column}}',
    optionsEmpty: 'Nothing found for "{{query}}".',
    min: 'Minimum',
    max: 'Maximum',
  },
  errors: {
    required: 'Required field',
  },
  breadcrumb: 'Breadcrumb',
  nav: {
    sidebar: 'Sidebar',
    allocations: 'Allocations',
    checks: 'Checks',
    pool: 'Pool',
    unallocated: 'Unallocated',
    projects: 'Projects',
    multiAllocated: 'Multi-allocated',
    summary: 'Summary',
    percentageCheck: 'Allocation % check',
    allocationTags: 'Allocation tags',
    language: 'Language',
    theme: 'Theme',
    userMenu: 'User menu',
  },
  themes: {
    light: 'Light',
    dark: 'Dark',
    system: 'System',
  },
  notFound: {
    title: 'Page not found',
    description: 'The page you are looking for does not exist or has been moved.',
    back: 'Back to home',
  },
  errorBoundary: {
    title: 'Something went wrong',
    description: 'An unexpected error occurred. Please reload the page and try again.',
    reload: 'Reload',
  },
} as const;
